import React, { useEffect } from 'react';
import { ConfigProvider } from 'tea-component';
import { getLocale } from 'umi';
import { getTeaLocale } from '@/pages/home/utils/lang';
import { DBOM_POINT } from '@opm/operationLog/buriedPoint';

let marketingBuriedPointInitialized = false;

interface IMarketingPageWrapProps {
  children: React.ReactNode;
}

const MarketingPageWrap: React.FC<IMarketingPageWrapProps> = ({ children }) => {
  const locale = getLocale();

  useEffect(() => {
    if (!marketingBuriedPointInitialized) {
      DBOM_POINT.init();
      marketingBuriedPointInitialized = true;
    }
  }, []);

  return (
    <div className="dbh-studio-marketing-page-wrap">
      <ConfigProvider locale={getTeaLocale(locale)}>
        {children}
      </ConfigProvider>
    </div>
  );
};

export default MarketingPageWrap;
